"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolarisIcon = exports.iconSources = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const polaris_1 = require("@shopify/polaris");
const polaris_icons_1 = require("@shopify/polaris-icons");
const problem_order_icon_svg_1 = require("./problem-order-icon.svg");
exports.iconSources = {
    problemOrders: problem_order_icon_svg_1.ProblemOrdersSVG,
    externalLink: polaris_icons_1.ExternalIcon,
    add: polaris_icons_1.PlusIcon,
    edit: polaris_icons_1.EditIcon,
    delete: polaris_icons_1.DeleteIcon
};
const StyledIcon = styled_components_1.default.span `
  .Polaris-Icon {
    height: inherit;
    margin: inherit;
  }
`;
const PolarisIcon = ({ accessibilityLabel, tone, iconStyle }) => {
    return (react_1.default.createElement(StyledIcon, null,
        react_1.default.createElement(polaris_1.Icon, { accessibilityLabel: accessibilityLabel, source: exports.iconSources[iconStyle] || polaris_icons_1.QuestionCircleIcon, tone: tone })));
};
exports.PolarisIcon = PolarisIcon;
